{
    "Venue-Rate-Quick-Search-Fields": [
      {
        "label": "Venue MPID", "columnname": "venueMPID", "placeholder": "Venue MPID",
        "width": "", "datatype": "String", "isLarge": false
      },
      {
        "label": "Venue Name", "columnname": "venueName", "placeholder": "Venue Name",
        "width": "", "datatype": "String", "isLarge": false
      }
    ],


    "Venue-Rate-Grid-Columns" : [
        {
            "display": "true",
            "ui_columnname": "Action",
            "db_columnname": "",
            "datatype": "",
            "mappingkey": "",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "isrequired": "false",
            "isFormField": "false", 
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Venue Name",
            "db_columnname": "venueName",
            "datatype": "String",
            "mappingkey": "venueName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "isrequired": "true",
            "isFormField": "true",
            "maxlength": 80, 
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Venue MPID",
            "db_columnname": "venueMPID",
            "datatype": "String",
            "mappingkey": "venueMPID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "isrequired": "true",
            "isFormField": "true", 
            "value": "",
            "maxlength": 7,
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Rate",
            "db_columnname": "rate",
            "datatype": "String",
            "mappingkey": "rate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "isrequired": "true",
            "isFormField": "true", 
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Effective Date",
            "db_columnname": "effectiveDate",
            "datatype": "Date",
            "mappingkey": "effectiveDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "isrequired": "true",
            "isFormField": "true", 
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Material Aspect",
            "db_columnname": "materialAspect",
            "datatype": "Text",
            "mappingkey": "materialAspect",
            "dropdown": "NO",
            "isdefault": "false",
            "isrequired": "true",
            "isFormField": "true",
            "disabled": false,
            "value": "",
            "maxlength": 500,
            "dropdowntype": "",
            "dropdownvalue": ""
        },        
        {
            "display": "true",
            "ui_columnname": "Created Date",
            "db_columnname": "createdDate",
            "datatype": "String",
            "mappingkey": "createdDate",
            "dropdown": "NO",
            "isdefault": "false",
            "isrequired": "false",
            "isFormField": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Updated Date",
            "db_columnname": "updatedDate",
            "datatype": "String",
            "mappingkey": "updatedDate",
            "dropdown": "NO",
            "isdefault": "false",
            "isrequired": "false",
            "isFormField": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Created User",
            "db_columnname": "createUser",
            "datatype": "String",
            "mappingkey": "createUser",
            "dropdown": "NO",
            "isdefault": "false",
            "isrequired": "false",
            "isFormField": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Updated User",
            "db_columnname": "lastUpdatedBy",
            "datatype": "String",
            "mappingkey": "lastUpdatedBy",
            "dropdown": "NO",
            "isdefault": "false",
            "isrequired": "false",
            "isFormField": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        }

    ]   

}